import { render, staticRenderFns } from "./DeviceDeliveryStats.vue?vue&type=template&id=86578630&scoped=true"
import script from "./DeviceDeliveryStats.vue?vue&type=script&lang=js"
export * from "./DeviceDeliveryStats.vue?vue&type=script&lang=js"
import style0 from "./DeviceDeliveryStats.vue?vue&type=style&index=0&id=86578630&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86578630",
  null
  
)

export default component.exports